import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EventService {

  private entityRefreshSub = new Subject();
  public entityRefresh$ = this.entityRefreshSub.asObservable();

  private filesLoadedSub = new Subject();
  public filesLoaded$ = this.filesLoadedSub.asObservable();

  constructor() { }

  public sendEntityRefresh() {
    this.entityRefreshSub.next();
  }

  public sendFilesLoaded() {
    this.filesLoadedSub.next();
  }

}
